<template>
  <router-view></router-view>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  created() {
    this.$store.dispatch("setMobsEnviroment");

    const clarityId = process.env.VUE_APP_CLARITY_ID;
    if (clarityId) {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", clarityId);
    }
  },
  computed: {
    queryKey() {
      return this.$route.query.key;
    },
  },
  methods: {
    ...mapActions({
      signWithLink: "autologin",
    }),
  },

  watch: {
    queryKey: {
      async handler(newKey) {
        if (newKey == null || newKey === "") return;
        await this.signWithLink(newKey);
      },
      immediate: true,
    },
  },
};
</script>

<style>
</style>
